import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Home.css";

const Home = () => {
  const [showAllCapabilityImages, setShowAllCapabilityImages] = useState(false);

  // Generate array of capability images
  const capabilityImages = Array.from({ length: 16 }, (_, index) => 
    `/images/nangLuc/Công bố năng lực Trung tâm thí nghiệm vật liệu và Khảo sát địa chất-images-${index}.jpg`
  );

  const displayedImages = showAllCapabilityImages ? capabilityImages : capabilityImages.slice(0, 3);
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero" style={{backgroundImage: `linear-gradient(rgba(44, 90, 160, 0.7), rgba(30, 63, 115, 0.7)), url(${process.env.PUBLIC_URL}/1.jpg)`}}>
        <div className="hero-overlay"></div>
        <div className="container">
          <div className="hero-content">
            <h1>Trắc địa Hải Phòng</h1>
            <h2>
              Công ty Cổ phần Khảo sát Thiết kế và Dịch vụ Thương mại Miền Bắc
            </h2>
            <p>
              Chuyên cung cấp dịch vụ khảo sát địa hình, thiết kế kỹ thuật và tư
              vấn xây dựng chuyên nghiệp tại Hải Phòng và các tỉnh miền Bắc
            </p>
            <div className="hero-buttons">
              <Link to="/services" className="btn btn-primary">
                Khám phá dịch vụ
              </Link>
              <Link to="/contact" className="btn btn-secondary">
                Liên hệ ngay
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Laboratory Capabilities */}
      <section className="laboratory-capabilities">
        <div className="container">
          <div className="lab-intro">
            <h2>🏢 Trung tâm Thí nghiệm LAS-XD27.004</h2>
            <p>Trung tâm thí nghiệm vật liệu và khảo sát địa chất được Sở Xây dựng Hải Phòng công nhận với đầy đủ năng lực thí nghiệm 102 chỉ tiêu chuyên ngành</p>
            
            <div className="lab-highlights">
              <div className="highlight-item">
                <div className="highlight-icon">📋</div>
                <div className="highlight-content">
                  <h4>Giấy chứng nhận</h4>
                  <p>Số 3335/GCN-SXD ngày 05/07/2024</p>
                </div>
              </div>
              <div className="highlight-item">
                <div className="highlight-icon">🔬</div>
                <div className="highlight-content">
                  <h4>Phạm vi thí nghiệm</h4>
                  <p>102 chỉ tiêu trong 12 nhóm chuyên ngành</p>
                </div>
              </div>
              <div className="highlight-item">
                <div className="highlight-icon">⏰</div>
                <div className="highlight-content">
                  <h4>Hiệu lực</h4>
                  <p>5 năm (đến năm 2029)</p>
                </div>
              </div>
            </div>

            <div className="lab-download-section">
              <h3>📄 Công bố năng lực thí nghiệm chuyên ngành xây dựng</h3>
              {/* Capability Images Gallery */}
              <div className="capability-images-section">
                <div className="capability-images-grid">
                  {displayedImages.map((imageSrc, index) => (
                    <div key={index} className="capability-image-item">
                      <img 
                        src={imageSrc} 
                        alt={`Năng lực thí nghiệm ${index + 1}`}
                        loading="lazy"
                      />
                    </div>
                  ))}
                </div>
                
                <div className="capability-images-controls">
                  <button 
                    className="btn btn-outline"
                    onClick={() => setShowAllCapabilityImages(!showAllCapabilityImages)}
                  >
                    {showAllCapabilityImages ? (
                      <>
                        <span>📤</span> Thu gọn
                      </>
                    ) : (
                      <>
                        <span>📥</span> Hiển thị thêm ({capabilityImages.length - 3} hình)
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <h2>Tại sao chọn chúng tôi?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🎯</div>
              <h3>Chuyên nghiệp</h3>
              <p>Đội ngũ kỹ sư giàu kinh nghiệm với chứng chỉ hành nghề</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⚡</div>
              <h3>Nhanh chóng</h3>
              <p>Thời gian thực hiện nhanh, đáp ứng tiến độ dự án</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">✅</div>
              <h3>Chất lượng</h3>
              <p>Cam kết chất lượng cao, tuân thủ tiêu chuẩn kỹ thuật</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💰</div>
              <h3>Giá cạnh tranh</h3>
              <p>Báo giá minh bạch, chi phí hợp lý</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="services-preview">
        <div className="container">
          <h2>Dịch vụ chính</h2>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">🗺️</div>
              <h3>Khảo sát địa hình</h3>
              <p>Đo đạc, khảo sát địa hình phục vụ thiết kế và thi công</p>
              <ul>
                <li>Khảo sát địa hình chi tiết</li>
                <li>Đo vẽ hiện trạng</li>
                <li>Lập bản đồ địa hình</li>
              </ul>
            </div>
            <div className="service-card">
              <div className="service-icon">🏗️</div>
              <h3>Thiết kế kỹ thuật</h3>
              <p>Thiết kế các hạng mục kỹ thuật theo quy chuẩn</p>
              <ul>
                <li>Thiết kế hạ tầng kỹ thuật</li>
                <li>Thiết kế cấp thoát nước</li>
                <li>Thiết kế giao thông</li>
              </ul>
            </div>
            <div className="service-card">
              <div className="service-icon">👷</div>
              <h3>Tư vấn xây dựng</h3>
              <p>Tư vấn giải pháp kỹ thuật tối ưu cho dự án</p>
              <ul>
                <li>Tư vấn thiết kế</li>
                <li>Giám sát thi công</li>
                <li>Nghiệm thu công trình</li>
              </ul>
            </div>
          </div>
          <div className="text-center">
            <Link to="/services" className="btn btn-primary">
              Xem tất cả dịch vụ
            </Link>
          </div>
        </div>
      </section>

      {/* Company Stats */}
      <section className="stats">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <h3>15+</h3>
              <p>Năm kinh nghiệm</p>
            </div>
            <div className="stat-item">
              <h3>500+</h3>
              <p>Dự án hoàn thành</p>
            </div>
            <div className="stat-item">
              <h3>100+</h3>
              <p>Khách hàng tin tưởng</p>
            </div>
            <div className="stat-item">
              <h3>24/7</h3>
              <p>Hỗ trợ khách hàng</p>
            </div>
          </div>
        </div>
      </section>

      {/* Recent Projects */}
      <section className="recent-projects">
        <div className="container">
          <h2>Dự án tiêu biểu gần đây</h2>
          <p className="section-subtitle">Những dự án nổi bật mà DSC.JSC đã thực hiện thành công</p>
          <div className="projects-showcase">
            <div className="project-item">
              <div className="project-image">
                <div className="placeholder-image">
                  <span>🛣️</span>
                </div>
              </div>
              <div className="project-info">
                <h4>Đường vành đai 3 Hải Phòng</h4>
                <p>Khảo sát địa hình 1/500, địa chất công trình và thí nghiệm 92 chỉ tiêu vật liệu</p>
                <div className="project-meta">
                  <span className="client">🏢 Ban QLDA ĐTXD Công trình Giao thông HP</span>
                  <span className="year">📅 2024</span>
                </div>
              </div>
            </div>
            <div className="project-item">
              <div className="project-image">
                <div className="placeholder-image">
                  <span>🚢</span>
                </div>
              </div>
              <div className="project-info">
                <h4>Cảng Tân Vũ – Lạch Huyện giai đoạn 3</h4>
                <p>Khảo sát địa chất nền cảng, thí nghiệm hiện trường SPT & CBR</p>
                <div className="project-meta">
                  <span className="client">🏢 Tổng công ty Tân Cảng Sài Gòn</span>
                  <span className="year">📅 2023</span>
                </div>
              </div>
            </div>
            <div className="project-item">
              <div className="project-image">
                <div className="placeholder-image">
                  <span>🏭</span>
                </div>
              </div>
              <div className="project-info">
                <h4>Khu công nghiệp DEEP C II</h4>
                <p>Khảo sát địa chất, đo đạc bản đồ địa chính 1/500, thí nghiệm 114 chỉ tiêu</p>
                <div className="project-meta">
                  <span className="client">🏢 Công ty TNHH DEEP C</span>
                  <span className="year">📅 2024</span>
                </div>
              </div>
            </div>
            <div className="project-item">
              <div className="project-image">
                <div className="placeholder-image">
                  <span>🚗</span>
                </div>
              </div>
              <div className="project-info">
                <h4>Nhà máy sản xuất Pin VinFast</h4>
                <p>Khảo sát địa chất và thí nghiệm bê tông sàn nhà máy giai đoạn 2</p>
                <div className="project-meta">
                  <span className="client">🏢 Công ty TNHH VinFast</span>
                  <span className="year">📅 2024</span>
                </div>
              </div>
            </div>
            <div className="project-item">
              <div className="project-image">
                <div className="placeholder-image">
                  <span>🌉</span>
                </div>
              </div>
              <div className="project-info">
                <h4>Cầu Hoàng Văn Thụ vượt sông Cấm</h4>
                <p>Khảo sát địa hình đáy sông, thí nghiệm SPT và mối hàn thép cầu</p>
                <div className="project-meta">
                  <span className="client">🏢 Ban QLDA ĐTXD Công trình Giao thông HP</span>
                  <span className="year">📅 2024</span>
                </div>
              </div>
            </div>
            <div className="project-item">
              <div className="project-image">
                <div className="placeholder-image">
                  <span>🏫</span>
                </div>
              </div>
              <div className="project-info">
                <h4>Trường Đại học Hải Phòng – Cơ sở mới</h4>
                <p>Khảo sát địa chất và thí nghiệm vật liệu xây dựng toàn diện</p>
                <div className="project-meta">
                  <span className="client">🏢 Đại học Hải Phòng</span>
                  <span className="year">📅 2023</span>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center">
            <Link to="/projects" className="btn btn-primary">
              Xem tất cả 37 dự án tiêu biểu
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
